export const useFormater = () => {
  const checkDigit = (event: KeyboardEvent) => {
    if (event.key?.length === 1 && isNaN(Number(event.key))) {
      event.preventDefault();
    }
  };

  return { checkDigit };
}

